/**
 * Shared calendar cell renderer for both range and single-date calendar modes.
 *
 * Used by AvailabilityRangeCalendar and AvailabilityDateCalendar — ONE cell
 * renderer, ONE CSS module ensures consistency is structural, not copy-pasted.
 *
 * Renders as a RAC <CalendarCell> which applies data-attributes:
 *   data-unavailable, data-selected, data-selection-start, data-selection-end,
 *   data-today, data-disabled, data-focus-visible, data-hovered
 * styled by availabilityCalendar.css via var() references.
 */
import React from 'react';
import { CalendarCell } from 'react-aria-components';

import type { CalendarDate } from '@internationalized/date';

interface CalendarCellContentProps {
  date: CalendarDate;
}

/**
 * Renders a single calendar day cell using RAC CalendarCell.
 * The RAC component applies the correct data-attributes and aria-* props.
 * Styling comes from availabilityCalendar.css (loaded by the consuming calendar).
 */
export function CalendarCellContent({ date }: CalendarCellContentProps): React.ReactElement {
  return <CalendarCell date={date} />;
}
